/**Packages */
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';


/* Flow */
import { handleFlow } from '../../../flow/index';

/* Components */
import AirbrakeErrorBoundary from '../AirbrakeErrorBoundary';

export const ProtectedRoute = ({ component: Component, history, ...rest }) => {
  const location = useLocation();
  const { pathname } = location;

  const returnPathName = localStorage.getItem('homePage') ? localStorage.getItem('homePage') : '/simulatore-commerciale.html';

  return (
    <Route {...rest}>
      {handleFlow(pathname) ? (
        <AirbrakeErrorBoundary>
          <Component />
        </AirbrakeErrorBoundary>
      ) : (
        <Redirect to={{ pathname: returnPathName, state: { from: location } }} />
      )}
    </Route>
  );
};
